<!-- event-calender.component.html -->
<mat-card class="demo-inline-calendar-card">
  <mat-calendar *ngIf="dates" [dateClass]="dateClass" [(selected)]="selected" (selectedChange)="openEventPopup()"></mat-calendar>
</mat-card>

